/**
 * Creates a service object with an auto-derived queryKey merged with any methods provided.
 * The caller is responsible for spreading whichever CRUD factory (if any) they need.
 *
 * @example — with path-param CRUD
 * export default createService(SLUG, {
 *   ...createPathParamCRUD<T, TPathParams>(SLUG),
 * });
 *
 * @example — with path-param CRUD plus extra segment fetchers
 * export default createService(SLUG, {
 *   ...createPathParamCRUD<TPractice, TPracticePathParams, IPracticeFilters>(SLUG, SEARCH_SLUG),
 *   getAllOrtho: getAllPathParam<TPractice, TPracticePathParams, IPracticeFilters>(
 *     `${SLUG}/ortho-offices`,
 *     `${SLUG}/search/ortho-offices`
 *   ),
 * });
 *
 * @example — no CRUD
 * export default createService(SLUG, {
 *   getSummary: ...,
 * });
 */
export const createService = <TMethods extends Record<string, unknown>>(
  slug: string,
  methods?: TMethods
) => ({
  queryKey: slug
    .replace(/^\/?api(\/v\d+)?\//, "")
    .split("/")
    .filter((s) => s && !/^\{.*\}$/.test(s)),
  slug: slug,
  ...(methods ?? ({} as TMethods)),
});
